/**
 * Calmy collection banner — background video.
 *
 * The <video> ships muted, playsinline and looping but is NOT autoplaying from
 * markup: the poster is painted, and this file decides whether motion starts.
 * That is what makes the reduced-motion path honest - a visitor who has asked
 * for less motion never has a frame of video played at them, rather than having
 * it started and then stopped.
 *
 * Autoplay can also simply be refused (low power mode, a browser setting). The
 * play() promise rejecting is the only reliable signal for that, so the control
 * is labelled from what actually happened rather than from what was intended.
 *
 * NO DUPLICATE HANDLERS: each banner carries its own flag, so a theme-editor
 * section reload re-running boot() over a wired banner is a no-op.
 */
(function () {
  "use strict";

  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)");

  function init(banner) {
    if (banner.__calmyBanner) return;
    banner.__calmyBanner = true;

    var video = banner.querySelector("[data-calmy-banner-video]");
    var toggle = banner.querySelector("[data-calmy-banner-toggle]");
    if (!video) return;

    var labelEl = banner.querySelector("[data-calmy-banner-togglelabel]");
    var playLabel = (toggle && toggle.getAttribute("data-label-play")) || "Play";
    var pauseLabel = (labelEl && labelEl.textContent.trim()) || "Pause";

    function paint(playing) {
      if (!toggle) return;
      /* aria-pressed describes the CONTROL's state - pressed means "paused by
         me" - and the label says what the next press will do. */
      toggle.setAttribute("aria-pressed", playing ? "false" : "true");
      if (labelEl) labelEl.textContent = playing ? pauseLabel : playLabel;
      toggle.setAttribute("aria-label", playing ? pauseLabel : playLabel);
    }

    function start() {
      var p = video.play();
      if (p && typeof p.then === "function") {
        p.then(function () { paint(true); }).catch(function () { paint(false); });
      } else {
        paint(!video.paused);
      }
    }

    if (REDUCED.matches) {
      /* Poster only. The control still works, so somebody who wants the motion
         can still ask for it. */
      paint(false);
    } else {
      start();
    }

    if (toggle) {
      toggle.addEventListener("click", function () {
        if (video.paused) start();
        else { video.pause(); paint(false); }
      });
    }

    /* Someone changing the system setting while the page is open. */
    var onChange = function () {
      if (REDUCED.matches && !video.paused) { video.pause(); paint(false); }
    };
    if (REDUCED.addEventListener) REDUCED.addEventListener("change", onChange);
    else if (REDUCED.addListener) REDUCED.addListener(onChange);

    /* Off-screen video is wasted battery and bandwidth. Paused when it scrolls
       away, resumed only if the visitor had not paused it themselves. */
    if ("IntersectionObserver" in window) {
      var userPaused = false;
      if (toggle) {
        toggle.addEventListener("click", function () { userPaused = video.paused; });
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (REDUCED.matches || userPaused) return;
          if (e.isIntersecting) start();
          else if (!video.paused) video.pause();
        });
      }, { threshold: 0.1 }).observe(video);
    }
  }

  function boot(root) {
    (root || document).querySelectorAll("[data-calmy-banner]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
